import { APP_LAST_UPDATED, APP_LOAD_SETTINGS } from '../types'

const initialState = {
	currentVersion: '1.1.46-bata',
	version: null,
	live: true,
	splashTitle: '',
	splashMessage: '',
	splashFooter: '',
	buttonShow: false,
	buttonText: '',
	buttonLink: '',
	updateIntervals: {   // update intervals in seconds
		groupCampaigns: 60,					// group/campaigns (10 minute update interval - 600 seconds )
		memberAccountSummary: 60,			// member/account (10 minute update interval - 600 seconds )
		memberCampaignsAndBoards: 60,		// member/donations (10 minute update interval - 600 seconds ) 
		memberDonationsAndBookmarks: 60,	// member/donations (10 minute update interval - 600 seconds )
		memberNotifications: 60,			// member/notifications (10 minute update interval - 600 seconds )
		memberSupport: 60,					// member/support (10 minute update interval - 600 seconds )
		publicBoards: 60,						// public/boards (10 minute update interval - 600 seconds )
		publicCampaigns: 60,					// public/campaigns (10 minute update interval - 600 seconds )
		publicView: 60,						// public/view (10 minute update interval - 600 seconds )
		paymentsCredits: 120,				// payments/paymentCredits (2 minutes update interval - 120)
		default: 60								// default interval (5 minute default update interval - 300 seconds - used if supplied interval is not valid)
	},
	lastUpdated: {}
}

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case APP_LAST_UPDATED:
        	return {
            ...state,
            lastUpdated: {
               ...state.lastUpdated,
               [action.payload.key]: action.payload.value
            }
        	}
      case APP_LOAD_SETTINGS:
			return { 
				...state,
				version: action.payload.version,
				live: action.payload.live,
				splashTitle: action.payload.splashTitle,
				splashMessage: action.payload.splashMessage,
				splashFooter: action.payload.splashFooter,
				buttonShow: action.payload.buttonShow,
				buttonText: action.payload.buttonText,
				buttonLink: action.payload.buttonLink
			}
		default:
			return state
	}
}
